import React from "react";
import { Link } from "react-router-dom";

function Logo({ logoSource, bootstrapNav }) {
  if (bootstrapNav) {
    return (
      <Link className="navbar-brand" to="/">
        <h1>Hello</h1>
      </Link>
    );
  }

  return (
    <div className="site-logo">
      <Link to="/">
        <h1>Hello</h1>
      </Link>
    </div>
  );
}

export default Logo;
